<template>
  <div class="user-login">
    <button v-if="!isLoggedIn" type="button" class="login-btn" @click="emit('login')">
      [{{ t('halloween.login') }}]
    </button>
    <template v-else>
      <span class="uid">{{ displayUid }}</span>
      <button type="button" class="login-btn" @click="emit('logout')">
        [{{ t('halloween.logout') }}]
      </button>
    </template>
    <div class="how-to-play">
      <button @click="showRuleDialog = true">
        {{ t('halloween.howToPlay') }}
      </button>
    </div>
    <RuleDialog v-model="showRuleDialog" />
  </div>
</template>

<script setup>
import { computed, defineEmits, ref } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import RuleDialog from '../Dialog/RuleDialog/index.vue'
const emit = defineEmits(['login', 'logout'])
const store = useStore()
const { t } = useI18n()

const showRuleDialog = ref(false)

const actUserInfo = computed(() => store.state.actUserInfo || {})
const activityInfo = computed(() => store.state.hwAct?.activityInfo)
const isLoggedIn = computed(() => !!actUserInfo.value?.token)
const displayUid = computed(
  () => activityInfo.value?.cpUserId || actUserInfo.value.uid || actUserInfo.value.cpUserId || '',
)
</script>

<style lang="less" scoped>
.user-login {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 23px;
  font-weight: bold;
  color: #fff;
  font-weight: bold;
}

.uid {
}

.login-btn {
  border: 0;
  background: transparent;
}

.how-to-play {
  button {
    border: 0;
    background: transparent;
    width: 192px;
    height: 62px;
    background: url('~@/views/act/halloween/assets/img/how-to-play-btn.png') no-repeat center center / 100% 100%;
    color: #FFFF76;
    padding: 0;
  }
}

</style>
